import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import template from './Details.vue';

import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import MDTextAreaWithValidation from '@/components/Validation/MDTextAreaWithValidation';
import Button from '@/components/Button';
import auth from '@/store/modules/auth';
import store from '@/store';
import { validation } from '@/_helpers/validation';
import { CustomerFormEdit, CustomerType } from '@/store/models/customer';
import customer from '@/store/modules/customer';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		ValidationProvider,
		MDTextFieldWithValidation,
		MDTextAreaWithValidation,
		Button
	}
})
export default class Details extends Vue {
	loading: boolean = false;

	form: { details: CustomerFormEdit } = {
		details: {
			id: '',
			name: '',
			email: '',
			phoneNumber: '',
			type: CustomerType.NONE,
			vat: '',
			invoiceSettings: {
				footer: ''
			}
		}
	};

	isBusiness: boolean = true;

	addVAT: boolean = false;

	mounted(): void {
		this.get(false);
	}

	async get(force: boolean): Promise<void> {
		this.loading = true;
		try {
			await auth.getSelf();
			const cst = await customer.get({ customerID: auth.self.customerId });
			this.form.details.id = cst.data.id;
			this.form.details.email = cst.data.email;
			this.form.details.name = cst.data.name;
			this.form.details.phoneNumber = cst.data.phoneNumber;
			this.form.details.vat = cst.data.vat;
			this.form.details.invoiceSettings.footer = cst.data.invoiceSettings.footer;
			if (cst.data.type === '') {
				this.form.details.type = CustomerType.BUSINESS;
			}
			if (cst.data.type === CustomerType.BUSINESS) {
				this.isBusiness = true;
			}
			if (this.form.details.vat !== '') {
				this.addVAT = true;
			}
		} catch (error) {
			store.commit('openNotifier', { text: `Er ging wat fout tijdens het ophalen van de gegevens`, color: 'error' });
			return;
		} finally {
			this.loading = false;
		}
	}

	async submit(): Promise<void> {
		this.loading = true;

		const isValid = await (this.$refs.formData as any).validate();
		if (!isValid) {
			this.loading = false;
			return;
		}
		try {
			if (this.isBusiness) {
				this.form.details.type = CustomerType.BUSINESS;
			} else {
				this.form.details.type = CustomerType.CONSUMER;
			}
			if (!this.addVAT) {
				this.form.details.vat = '';
			}
			await customer.update(this.form.details);
			store.commit('openNotifier', { text: `De gegevens zijn opgeslagen`, color: 'success' });
		} catch (error) {
			(this.$refs.formData as any).setErrors(validation.getErrors(error.data.errors));
			return;
		} finally {
			this.loading = false;
		}
	}
}
